/**
 * Klein klantlogo vóór de projectnaam op een taakblok (Joris, 3 nov 2026: "de logo's erbij
 * zoals in Airtable"). Bron: `taak.klantLogo` uit de engine (Bedrijven → Logo (Emblem), de
 * kleine thumbnail; verlopen Airtable-URL's ververst de engine zelf). Zonder logo, of als de
 * afbeelding niet laadt: de initialen van de klant in een rustig grijs rondje.
 */
import React, { useState } from 'react';
import { Box } from '@mui/material';

/** "Provincie Noord-Brabant" → "PN", "KIWA" → "KI", leeg → "". */
export function klantInitialen(naam) {
  const woorden = String(naam || '').replace(/[^\p{L}\p{N}\s]/gu, ' ').trim().split(/\s+/).filter(Boolean);
  if (!woorden.length) return '';
  if (woorden.length === 1) return woorden[0].slice(0, 2).toUpperCase();
  return (woorden[0][0] + woorden[1][0]).toUpperCase();
}

export default function KlantLogo({ url, klant, maat = 14, inline = false }) {
  // Onthoud wélke URL niet laadde: komt er (na verversen) een nieuwe, dan opnieuw proberen.
  const [kapotUrl, setKapotUrl] = useState(null);
  const kapot = Boolean(url) && kapotUrl === url;
  const initialen = klantInitialen(klant);
  if ((!url || kapot) && !initialen) return null;
  const basis = {
    width: maat, height: maat, flexShrink: 0, borderRadius: '50%',
    border: '1px solid #e5e7eb', bgcolor: '#fff', alignSelf: 'center',
    // In een (afgekapte) tekstregel, zoals de bovenregel van een roosterblok.
    ...(inline && { display: 'inline-block', verticalAlign: '-2px', mr: '4px' }),
  };
  if (url && !kapot) {
    return (
      <Box component="img" src={url} alt="" aria-hidden="true" data-testid="klant-logo"
        onError={() => setKapotUrl(url)} loading="lazy" referrerPolicy="no-referrer"
        sx={{ ...basis, objectFit: 'contain' }} />
    );
  }
  return (
    <Box component="span" aria-hidden="true" data-testid="klant-initialen"
      sx={{
        bgcolor: '#f1f5f9', color: '#64748b', display: 'inline-flex', ...basis,
        alignItems: 'center', justifyContent: 'center',
        fontSize: Math.max(7, Math.round(maat * 0.5)), fontWeight: 700, lineHeight: 1,
      }}>
      {initialen}
    </Box>
  );
}
